import React, { Component } from 'react'
import { Doughnut } from 'react-chartjs-2';
import NavViews from '../../stores/NavViews';
import { inject, observer } from 'mobx-react';
import { Provider } from "mobx-react"
import CancelBet from '../appComponents/betting/betStages/CancelBet'
import SubmitVote from '../appComponents/betting/betStages/SubmitVote'
import SubmitSecondVote from '../appComponents/betting/betStages/SubmitSecondVote'
import GetPaid from '../appComponents/betting/betStages/GetPaid'
import Countdown from 'react-countdown-now';
import { Icon, Menu, Dropdown } from 'antd';
import { FaTelegram, FaWhatsapp, FaUserSecret } from 'react-icons/fa';
import Color from 'color'
import { FacebookShareButton, TwitterShareButton, EmailShareButton, TelegramShareButton, WhatsappShareButton } from 'react-share'
const ethMultiplier = 1000000000000000000;
const betCopy = "Take the other side of the bet I just made on mevu.bet!";
@observer(["eventStore", "WagerStore", "UserStore", "TeamStore", "CustomRouter", "AdminStore"])
class MyBetsCards extends Component {
    constructor(props) {
        super(props);

        this.state = {
            teamOneLogo: "",
            teamTwoLogo: "",
            teamOneName: "",
            teamTwoName: "",
            wagers: {},
            teamOneAbbreviation: "",
            teamTwoAbbreviation: "",
            loadingColors: true,
            propEvents: [],
            renderedWagers: <Icon type="loading" />
        };

        this.renderStage = this.renderStage.bind(this);
    }
    async componentWillMount() {
        const { TeamStore } = this.props;
        TeamStore.queryTeams();
    }

    async componentDidMount() {
        const { TeamStore, event } = this.props;
        const {
            amountBetForOne,
            amountBetForTwo
        } = this.props.event;

        let team_one = this.props.event.teams[0];
        let team_two = this.props.event.teams[1];
        let self = this;
        setTimeout(() => {
            TeamStore.teams.forEach(function (team) {
                if (team_one == team._id) {
                    self.setState({
                        teamOneLogo: team.logoUrl,
                        teamOneName: team.name,
                        teamOneAbbreviation: team.abbreviation,
                    });
                }
                if (team_two == team._id) {
                    self.setState({
                        teamTwoLogo: team.logoUrl,
                        teamTwoName: team.name,
                        teamTwoAbbreviation: team.abbreviation
                    });
                }
            });
            // console.log("teams: " + JSON.stringify(TeamStore));
        }, 30);



        this.props.betsMade.forEach((bet) => {
            let currentPropEventStore = this.state.propEvents;
            if (bet.wager.eventId != event._id) {
                this.props.eventStore.events.forEach((eventInStore) => {
                    if (eventInStore._id == bet.wager.eventId) {
                        currentPropEventStore.push(eventInStore);
                        this.setState({ propEvents: currentPropEventStore });
                    }
                });


            }

        });



        this.props.betsTaken.forEach((bet) => {
            let currentPropEventStore = this.state.propEvents;
            if (bet.wager.originalEventId == event._id) {
                this.props.eventStore.events.forEach((eventInStore) => {
                    if (eventInStore._id == bet.wager.eventId) {
                        currentPropEventStore.push(eventInStore);
                        this.setState({ propEvents: currentPropEventStore });
                    }
                });


            }

        });

        setTimeout(() => {
            self.setState({ loadingColors: false });
            this.renderWagers();
        }, 150);
    }


    round(value) {
        return Math.round(value * 100) / 100;
    }

    renderWager(wager, makerTaker, stage) {
        const { eventStore, event } = this.props;
        let team_one = this.state.teamOneName;
        let team_two = this.state.teamTwoName;
        //let event;
        let teamChoice = "";
        const roundingMultiplier = 1000000000;
        // console.log("entire evens store " + JSON.stringify(eventStore.events));
        // event = eventStore.events.get(wager.eventId);
        console.log("event is " + event);
        console.log("WAGER IS " + JSON.stringify(wager))    ;
        console.log("MAkertAker " + JSON.stringify(makerTaker));

        if (event._id == wager.eventId) {
            if (makerTaker == "taker") {
                if (wager.makerChoice == 1) {
                    teamChoice = team_two;
                }
                else {
                    teamChoice = team_one;
                }
            }
            else if (makerTaker == "maker") {
                if (wager.makerChoice == 1) {
                    teamChoice = team_one;
                }
                else {
                    teamChoice = team_two;
                }
            }
        } else {
            console.log("prop events! " + this.state.propEvents)
            this.state.propEvents.forEach((propEvent) => {
                if (propEvent._id == wager.eventId) {

                    if (makerTaker == "taker") {
                        teamChoice = propEvent.propTitle + " - " + (wager.makerChoice == 2 ? propEvent.teams[0] : propEvent.teams[1]);

                    }
                    else if (makerTaker == "maker") {

                        teamChoice = propEvent.propTitle + " - " + (wager.makerChoice == 1 ? propEvent.teams[0] : propEvent.teams[1]);

                    }


                }
            });


        }
        const menu = (
            <Menu theme={"dark"} style={{ width: "50px" }}>
                <Menu.Item>
                    <FacebookShareButton children={<Icon style={{ fontSize: "26px", color: 'white' }} type="facebook" />} quote={betCopy} url={"https://dapp.mevu.bet/take_bet/" + wager._id} />
                </Menu.Item>
                <Menu.Item>
                    <TwitterShareButton children={<Icon style={{ fontSize: "26px", color: 'white' }} type="twitter" />} title={betCopy} url={"https://dapp.mevu.bet/take_bet/" + wager._id} />
                </Menu.Item>
                <Menu.Item>
                    <TelegramShareButton children={

                        <FaTelegram style={{ fontSize: "26px", color: 'white' }} />
                    }
                        title={betCopy} url={"https://dapp.mevu.bet/take_bet/" + wager._id} />
                </Menu.Item>
                <Menu.Item>
                    <WhatsappShareButton children={

                        <FaWhatsapp style={{ fontSize: "26px", color: 'white' }} />
                    }
                        title={betCopy} url={"https://dapp.mevu.bet/take_bet/" + wager._id} />
                </Menu.Item>
                <Menu.Item>
                    <EmailShareButton children={<Icon style={{ fontSize: "26px", color: 'white' }} type="mail" />} subject={betCopy} url={"https://dapp.mevu.bet/take_bet/" + wager._id} />
                </Menu.Item>
            </Menu>
        );




        return (
            <div className="my-bets-page-cards-wagers-wager-wrapper" key={wager._id}>
                <div className="my-bets-page-cards-wagers-grid">
                    <div className="my-bets-page-cards-wagers-wager-potential-stage">

                        <div className="my-bets-page-cards-wagers-team-choice">{teamChoice}</div>
                        <div className="my-bets-page-cards-wagers-wager-potential-win">Potential Win: {makerTaker == "taker" ? <span>{(wager.value / ethMultiplier).toFixed(4)}</span> : <span>{wager.odds > 99 ? ((wager.value / (wager.odds / 100)) / ethMultiplier).toFixed(4) :
                            ((wager.value * Math.floor(100 / wager.odds)) / ethMultiplier).toFixed(4)} ETH</span>}</div>
                    </div>
                    <div className="my-bets-page-cards-wagers-wager-grid">
                        <div className="my-bets-page-cards-wagers-wager-stake"><div>Stake</div>{makerTaker == "taker" ? (wager.odds > 99 ? ((wager.value / (wager.odds / 100)) / ethMultiplier).toFixed(4) : ((wager.value * Math.floor(100 / wager.odds)) / ethMultiplier).toFixed(4))
                            : (wager.value / ethMultiplier).toFixed(4)}ETH</div>
                        <div className="my-bets-page-cards-wagers-wager-odds"><div>Odds</div> {wager.odds / 100}</div>
                    </div>


                    {this.renderStage(stage, wager, makerTaker)}

                    {/* <div className="my-bets-page-cards-wagers-wager-options">
                        <div className="my-bets-page-cards-wagers-wager-options-cancel">
                            <CancelBet bet={wager} />
                        </div>
                    </div> */}

                    <div style={{ position: "absolute", marginLeft: "0px", marginTop: "0px" }}>
                        {wager.isPrivate ? <span style={{ color: 'gray', fontSize: '14px' }}>PRIVATE <FaUserSecret /></span> :
                            <span style={{ color: 'gray', fontSize: '14px' }}>PUBLIC <Icon type="notification" /></span>}

                        {!wager.cancelled && !wager.settled && wager.taker == "" ? <div> <Dropdown overlay={menu}>
                            <a className="ant-dropdown-link" href="#">
                                <Icon style={{ fontSize: "26px" }} type="share-alt" />
                            </a>
                        </Dropdown>
                        </div> : ""}
                    </div>


                </div>

            </div >
        );
    }

    renderStage(status, wager, makerTaker) {
        // let { startTimeNumber, duration } = this.props;
        let component = [];
        // console.log("rendering stage of wager " + JSON.stringify(wager));
        // console.log("TAKER " + wager.taker);
        // if (wager.settled) {
        //     return <div>Settled</div>
        // } else if (wager.cancelled) {
        //     return <div>Cancelled</div>
        // } else if (wager.taker == "" && Date.now() / 1000 > startTimeNumber + duration) {
        //     return <div className="my-bets-page-cards-wagers-wager-odds">Event is over and nobody took wager, click to cancel</div>
        // } else if (wager.taker == "" && Date.now() / 1000 < startTimeNumber + duration) {
        //     return <div className="my-bets-page-cards-wagers-wager-odds">Waiting for taker</div>
        // } else if (wager.taker != "" && Date.now() / 1000 < startTimeNumber + duration) {
        //     return <div className="my-bets-page-cards-wagers-wager-odds">Waiting for event to finish</div>
        // } else {
        //     return null
        // }
        if (status == "untaken-pregame") {
            component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Waiting for match</div>);
            component.push(<div className="my-bets-page-cards-wagers-wager-options">
                <div className="my-bets-page-cards-wagers-wager-options-cancel">
                    <CancelBet bet={wager} />
                </div>
            </div>);
        } else if (status == "untaken-postgame") {
            component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Never found a match</div>);
            component.push(<div className="my-bets-page-cards-wagers-wager-options">
                <div className="my-bets-page-cards-wagers-wager-options-cancel">
                    <CancelBet bet={wager} />
                </div>
            </div>);
        } else if (status == "novotes-postgameprefinalized") {
            component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Submit the winner</div>);
            component.push(<div className="my-bets-page-cards-wagers-wager-options">
                <div className="my-bets-page-cards-wagers-wager-options-cancel">
                    <SubmitVote bet={wager} event={this.props.event} propEvent={this.props.propEvent} />
                </div>
            </div>);
        } else if (status == "novotes-postgamepostfinalized") {
            component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Event has been finalized, if you won click for payout.</div>);
            component.push(<div className="my-bets-page-cards-wagers-wager-options">
                <div className="my-bets-page-cards-wagers-wager-options-cancel">
                    <GetPaid bet={wager} event={this.props.event} propEvent={this.props.propEvent} />
                </div>
            </div>);
        } else if (status == "onlymakervoted-preeventfinalized") {
            if (makerTaker == "maker") {
                component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Waiting for opponent to submit their vote</div>);
            } else {
                component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Submit the winner</div>);
                component.push(<div className="my-bets-page-cards-wagers-wager-options">
                    <div className="my-bets-page-cards-wagers-wager-options-cancel">
                        <SubmitSecondVote bet={wager} event={this.props.event} propEvent={this.props.propEvent} />
                    </div>
                </div>);

            }
        }
        else if (status == "onlymakervoted-posteventfinalized") {
            if (makerTaker == "maker") {
                component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Event has been finalized, if you won click for payout.</div>);
                component.push(<div className="my-bets-page-cards-wagers-wager-options">
                    <div className="my-bets-page-cards-wagers-wager-options-cancel">
                        <GetPaid bet={wager} event={this.props.event} propEvent={this.props.propEvent} />
                    </div>
                </div>);
            } else {
                component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Event has been finalized, if you won submit vote to initiate payout.</div>);
                component.push(<div className="my-bets-page-cards-wagers-wager-options">
                    <div className="my-bets-page-cards-wagers-wager-options-cancel">
                        <SubmitSecondVote bet={wager} event={this.props.event} propEvent={this.props.propEvent} />
                    </div>
                </div>);

            }
        } else if (status == "onlytakervoted-preeventfinalized") {
            if (makerTaker == "taker") {
                component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Waiting for opponent to submit their vote</div>);
            } else {
                component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Submit the winner</div>);
                component.push(<div className="my-bets-page-cards-wagers-wager-options">
                    <div className="my-bets-page-cards-wagers-wager-options-cancel">
                        <SubmitSecondVote bet={wager} event={this.props.event} propEvent={this.props.propEvent} />
                    </div>
                </div>);

            }


        } else if (status == "onlytakervoted-posteventfinalized") {
            if (makerTaker == "taker") {
                component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Event has been finalized, if you won click for payout.</div>);
                component.push(<div className="my-bets-page-cards-wagers-wager-options">
                    <div className="my-bets-page-cards-wagers-wager-options-cancel">
                        <GetPaid bet={wager} event={this.props.event} propEvent={this.props.propEvent} />
                    </div>
                </div>);

            } else {
                component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Submit the winner</div>);
                component.push(<div className="my-bets-page-cards-wagers-wager-options">
                    <div className="my-bets-page-cards-wagers-wager-options-cancel">
                        <SubmitVote bet={wager} event={this.props.event} propEvent={this.props.propEvent} />
                    </div>
                </div>);

            }


        } else if (status === "settled-nodispute" || status === "settled") {
            let takerWon = false;
            let makerWon = false;
            let noWinner = false;
            console.log("wager.maker - " + wager);
            //console.log("wager.winner - " + wager.winner);
            if (wager.maker == wager.winner) {
                makerWon = true;
            } else if (wager.taker == wager.winner) {
                takerWon = true;
            } else if (wager.taker != wager.winner && wager.maker != wager.winner) {
                noWinner = true;
            }
            if (makerTaker === "taker") {
                if (takerWon) {
                    component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">SETTLED</div>);
                    component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">
                        <span style={{ color: '#27f727' }}>YOU WON</span></div>);
                } else if (makerWon) {
                    component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">SETTLED</div>);
                    component.push(<div className="my-bets-page-cards-wagers-wager-options-stage"><span style={{ color: 'rgb(245, 60, 64)' }}>YOU LOST</span></div>);
                } else if (noWinner) {
                    component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">SETTLED</div>);
                    component.push(<div className="my-bets-page-cards-wagers-wager-options-stage"><span style={{ color: 'rgb(209, 174, 94)' }}>NO WINNER COULD BE DECIDED, YOU WERE REFUNDED</span></div>);

                }
            } else {
                if (makerWon) {
                    component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">SETTLED</div>);
                    component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">  <span style={{ color: '#27f727' }}>YOU WON</span></div>);
                } else if (takerWon) {
                    component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">SETTLED</div>);
                    component.push(<div className="my-bets-page-cards-wagers-wager-options-stage"><span style={{ color: 'rgb(245, 60, 64)' }}>YOU LOST</span></div>);
                } else if (noWinner) {
                    component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">SETTLED</div>);
                    component.push(<div className="my-bets-page-cards-wagers-wager-options-stage"><span style={{ color: 'rgb(209, 174, 94)' }}>NO WINNER COULD BE DECIDED, YOU WERE REFUNDED</span></div>);

                }
            }
        } else if (status === "dispute-settlednotpaid") {
            component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">SETTLED BY ORACLES</div>);
            component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">  <GetPaid bet={wager} event={this.props.event} propEvent={this.props.propEvent} /></div>);
        } else if (status === "dispute-settledpaid") {
            let takerWon = false;
            let makerWon = false;
            let noWinner = false;
            console.log("wager.maker - " + wager);
            //console.log("wager.winner - " + wager.winner);
            if (wager.maker == wager.winner) {
                makerWon = true;
            } else if (wager.taker == wager.winner) {
                takerWon = true;
            } else if (wager.taker != wager.winner && wager.maker != wager.winner) {
                noWinner = true;
            }
            if (makerTaker === "taker") {
                if (takerWon) {
                    component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">SETTLED BY ORACLES</div>);
                    component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">
                        <span style={{ color: '#27f727' }}>YOU WON</span></div>);
                } else if (makerWon) {
                    component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">SETTLED BY ORACLES</div>);
                    component.push(<div className="my-bets-page-cards-wagers-wager-options-stage"><span style={{ color: 'rgb(245, 60, 64)' }}>YOU LOST</span></div>);
                } else if (noWinner) {
                    component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">SETTLED BY ORACLES</div>);
                    component.push(<div className="my-bets-page-cards-wagers-wager-options-stage"><span style={{ color: 'rgb(209, 174, 94)' }}>NO WINNER COULD BE DECIDED, YOU WERE REFUNDED</span></div>);

                }
            } else {
                if (makerWon) {
                    component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">SETTLED BY ORACLES</div>);
                    component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">  <span style={{ color: '#27f727' }}>YOU WON</span></div>);
                } else if (takerWon) {
                    component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">SETTLED BY ORACLES</div>);
                    component.push(<div className="my-bets-page-cards-wagers-wager-options-stage"><span style={{ color: 'rgb(245, 60, 64)' }}>YOU LOST</span></div>);
                } else if (noWinner) {
                    component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">SETTLED BY ORACLES</div>);
                    component.push(<div className="my-bets-page-cards-wagers-wager-options-stage"><span style={{ color: 'rgb(209, 174, 94)' }}>NO WINNER COULD BE DECIDED, YOU WERE REFUNDED</span></div>);

                }
            }


        } else {
            component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">{status}</div>);
        }
        return component;
    }

    renderWagers() {
        const { UserStore, event_id } = this.props;
        let wagerList = [];

        //    // if (makerTaker == "maker") {
        //         for (let wager of UserStore.betsMade.values()) {
        //             if (wager.eventId === event_id) {
        //                 wagerList.push(this.renderWager(wager, "maker"));
        //             }
        //         }
        //    // }

        //    // else if (makerTaker == "taker") {
        //         for (let wager of UserStore.betsTaken.values()) {
        //             if (wager.eventId === event_id) {
        //                 wagerList.push(this.renderWager(wager, "taker"));
        //             }
        //         }
        //   //  }

        for (let wager of this.props.betsMade) {
            wagerList.push(this.renderWager(wager.wager, "maker", wager.status));
        }
        for (let wager of this.props.betsTaken) {
            wagerList.push(this.renderWager(wager.wager, "taker", wager.status));
        }
        console.log("AMOUNT OF WAGERS :::" + wagerList.length)
        // return wagerList;
        this.setState({ renderedWagers: wagerList });
    }

    render() {
        let team_one = this.state.teamOneName;
        let team_two = this.state.teamTwoName;
        let startTime = new Date();
        startTime.setTime(this.props.event.startTime * 1000);
        let start_time = startTime.toLocaleTimeString() + " - " + startTime.toLocaleDateString();
        let startTimeNumber = this.props.event.startTime;

        const { event_id, duration } = this.props.event;
        let drawPossible = this.state.drawPossible;

        const { CustomRouter, UserStore, AdminStore } = this.props;
        const { router: { goTo } } = CustomRouter;


        const DoughnutData = {
            labels: [
                this.state.teamTwoAbbreviation.toUpperCase(),
                this.state.teamOneAbbreviation.toUpperCase(),
            ],
            datasets: [{
                data: [(this.props.event.amountBetForTwo/ethMultiplier).toFixed(4), (this.props.event.amountBetForOne/ethMultiplier).toFixed(4)],
                backgroundColor: [
                    this.props.event.teamTwoColor,
                    this.props.event.teamOneColor,
                ],
                hoverBackgroundColor: [
                    this.props.event.teamTwoColor,
                    this.props.event.teamOneColor,
                ],
                borderColor: [
                    'rgba(255, 255, 255, 0)',
                    'rgba(255, 255, 255, 0)',
                ],
            }]
        };

        let timeNow = Date.now();
        let eventEndTime = new Date(startTimeNumber + this.props.event.duration).getTime() * 1000;
        let oraclePeriod = AdminStore.oraclePeriod * 1000;

        return (
            <div className={eventEndTime > timeNow ? "my-bets-page-cards-open" : eventEndTime + oraclePeriod < timeNow ? "my-bets-page-cards-closed" : "my-bets-page-cards-oracle"}>
                <div className="my-bets-page-rows-teams-wrap" onClick={() => goTo(NavViews.singleEvent, { eventID: this.props.event._id }, CustomRouter)}>
                    <div className="my-bets-page-rows-teams">
                        <div className="my-bets-page-rows-teams-teamone">
                            <span><img src={this.state.teamOneLogo} /></span>
                            {/* //src="http://www.countryflags.io/CA/flat/64.png" width="30px" /></span> */}
                            <div>{team_one}</div>
                        </div>
                        <div className="my-bets-page-rows-teams-vs">
                            <div style={{ marginTop: '-10px' }}>
                                {this.state.loadingColors ? <Icon style={{ color: '#40a9ff', fontSize: '60px' }} type="loading" /> : <Doughnut
                                    legend={null}
                                    width={110}
                                    options={{
                                        maintainAspectRatio: false
                                    }}
                                    height={55}
                                    data={DoughnutData}
                                />}

                            </div>
                        </div>
                        <div className="my-bets-page-rows-teams-teamtwo">
                            <span><img src={this.state.teamTwoLogo} /></span>
                            <div>{team_two}</div>
                        </div>
                    </div>
                    <div className="my-bets-page-cards-event-info" onClick={() => goTo(NavViews.singleEvent, { eventID: this.props.event._id }, CustomRouter)}>

                        <div>{start_time}</div>

                    </div>
                </div>
                <div className="my-bets-page-cards-wagers">

                    {this.state.renderedWagers}
                </div>
                <div className="my-bets-page-cards-status" onClick={() => goTo(NavViews.singleEvent, { eventID: this.props.event._id }, CustomRouter)}>
                    <div style={{ padding: '14px 0px 0px 0px', color: eventEndTime + oraclePeriod < timeNow ? "#f73527" : (eventEndTime < timeNow ? "#f48541" : "#27f727"), textAlign: 'left' }}>
                        <div className={eventEndTime + oraclePeriod < timeNow ? "closed-icon" : eventEndTime < timeNow ? "oracle-icon" : "open-icon"}></div><span style={{ display: 'inline-block', marginLeft: '20px' }}>{eventEndTime > timeNow ? "OPEN" : eventEndTime + oraclePeriod < timeNow ? "ENDED" : "ORACLE PERIOD"}</span>
                        <span className="main-page-cards-status-time-remaining" style={{ float: 'right', marginTop: '-14px' }} >
                            <Countdown zeroPadLength={2} date={new Date(startTimeNumber + this.props.event.duration).getTime() * 1000}>
                                <span></span>
                            </Countdown>
                            <span style={{ marginLeft: '5px' }}>{eventEndTime > timeNow ? "REMAINING" : null}</span>
                        </span>
                    </div>

                </div>


            </div>

        );
    }
}

export default MyBetsCards;


// WEBPACK FOOTER //
// ./src/components/layoutComponents/MyBetsCards.js